import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealService } from '../deal.service';
import { Deal, DealPagedRequest, FlowType } from '../model';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TagModule } from 'primeng/tag';
import { NotificationTypePipe } from '../pipes/notification-type.pipe';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-auto-renewal-deals',
  imports: [
    FormsModule, InputTextModule,
    TableModule, ButtonModule, TagModule, IconFieldModule, InputIconModule,
    DatePipe, FormsModule, NgFor, NgIf, NotificationTypePipe
  ],
  templateUrl: './auto-renewal-deals.component.html',
  styleUrl: './auto-renewal-deals.component.scss'
})
export class AutoRenewalDealsComponent implements OnInit {

  public req: DealPagedRequest = {
    page: 0,
    pageSize: 20,
    type: FlowType.OVERDUE
  };

  @ViewChild('dt3') dt: Table | undefined;

  protected deals: Deal[] = [];
  protected total: number = 0;
  protected isLoading: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: DealService
  ) {

  }

  ngOnInit(): void {
    this.activatedRoute.url.subscribe(url => {
      const path = url[1].path;

      if (path == "ovedues") {
        this.req.type = FlowType.OVERDUE;
      } else if (path == "renewals") {
        this.req.type = FlowType.RENEWAL;
      }
    });
  }

  filterGlobal(event: any) {
    this.dt?.filterGlobal(event.target.value, 'contains');
  }

  loadDealsLazy(ev: TableLazyLoadEvent) {
    console.log(ev);
    this.service.list({
      type: this.req.type,
      pageSize: this.req.pageSize,
      page: (ev.first ?? 0) / this.req.pageSize,
      filter: ev.globalFilter as string
    }).subscribe(data => {
      this.deals = data.items;
      this.total = data.total;
    });
  }

  edit(item: Deal) {
    console.log('Edit', item);
  }
}
